var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trend-percentage-wrapper"},[(_vm.showPercentage)?_c('span',{class:{
      'text-up': _vm.isPositive,
      'text-down': _vm.isNegative,
      'text-neutral': _vm.isNeutral,
      'mr-2': _vm.showPercentage && _vm.showArrow
    }},[(_vm.showPercentageIcon)?_c('span',[_vm._v(" "+_vm._s(_vm._f("formatNumbers")(_vm.percentageFormatted))+"% ")]):_c('span',[_vm._v(" "+_vm._s(_vm._f("formatNumbers")(_vm.percentageFormatted,0))+" ")])]):_vm._e(),(_vm.showArrow)?_c('img',{attrs:{"src":require(("@/assets/img/" + _vm.arrowIcon + ".svg")),"width":_vm.arrowWidth,"alt":_vm.arrowIcon}}):_vm._e(),(_vm.hasLabel)?_c('span',{staticClass:"ml-2 text-sm text-bold",class:{
      'text-up': _vm.isPositive,
      'text-down': _vm.isNegative,
      'text-neutral': _vm.isNeutral,
    }},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }